import axios from './axios';

const API_URL = process.env.REACT_APP_API_URL;

// Formatta una data "YYYY-MM-DD HH:mm:ss" in "DD/MM/YYYY ore HH:mm" per le pagine pubbliche di gestione link
export const formatDateTime = (value) => {
  if (!value) return '';
  const [date, time] = value.split(' ');
  const [y, m, d] = date.split('-');
  return `${d}/${m}/${y} ore ${time}`;
};

// Helper comune per i messaggi d'errore delle API, riesportato per le pagine che lo importano da qui
export { errorMessage } from '../utils/errorMessage';

// Link di gestione ricevuti via email/SMS/push: nessun login, il token è la chiave
export default {
  reservation: async (token) => await axios.get(`${API_URL}/public/reservation/${token}`),

  cancelReservation: async (token) => await axios.post(`${API_URL}/public/reservation/${token}/cancel`),

  confirmAttendance: async (token) => await axios.post(`${API_URL}/public/reservation/${token}/attendance`),

  vaccine: async (token) => await axios.get(`${API_URL}/public/vaccine/${token}`),

  respondVaccine: async (token, response) =>
    await axios.post(`${API_URL}/public/vaccine/${token}/respond`, { response }),
};
